<div class="rd-widget rd-widget-no-height-restriction widget-{{widgetConfig.widgetId}} esg-interior-description-office-widget" *ngIf="widgetData">
  <table class="widget-large" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-flex">
        <th scope="col" colspan="12" class="widget-grid-column esg-interior-description-office-widget-header-red">
          <div class="esg-interior-description-office-widget-header">
            <ng-container *ngIf="editMode">
              <span class="k-icon k-i-minus" (click)="deleteCurrentRow()"></span>
              <span class="k-icon k-i-plus" (click)="addRow()" *ngIf="sectionHasAvailableFields('esgInteriorDescription')"></span>
              <span class="k-icon k-i-arrow-up" (click)="moveCurrentRowUp()"></span>
              <span class="k-icon k-i-arrow-down" (click)="moveCurrentRowDown()"></span>
            </ng-container>
          </div>
          <widget-value class="esg-interior-description-office-widget-header" [align]="'left'" [color]="'white'" [bold]="true" style="width: 100%">{{'esgInteriorDescription.labelEsgInteriorDescriptionOfficeTitle' | rdTranslate}}</widget-value>
        </th>
      </tr>
    </thead>
    <tbody>
      <rd-textandlist-section [widget]="this" [widgetId]="this.widgetConfig.widgetId" [page]="page" [selectedTag]="hashTag" [sectionName]="textAndListSectionName" [reflists]="reflists" [topicReflist]="'ref_l3_esg_interior_description_topics'"
                              [editMode]="editMode" [rows]="rows" [leftColspan]="6" [rightColspan]="6" [data]="widgetData ? widgetData : null"
                              [alternatingColorScheme]="true" [currency]="currency" [unitOfArea]="unitOfArea" [addRow]="addRow$"
                              [deleteCurrentRow]="deleteCurrentRow$" [moveCurrentRowUp]="moveCurrentRowUp$"
                              [moveCurrentRowDown]="moveCurrentRowDown$" (dataChanged)="onDataChanged()"
                              (sectionRowsCountChanged)="sectionRowsCountChanged($event)">
      </rd-textandlist-section>
    </tbody>
  </table>
</div>
